export default {
      id: "i-menu-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu",
      toString: function () {
        return this.url;
      }
    }